import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { EsgAddIcon, EyeIcon } from "assets";
import { COLORS, Label14Medium, Label14SemiBold, Label16SemiBold, Loading, SettingButtonText } from "components";
import { AllowedValuesDTO, getUtilityThreshold } from "api";
import { ThresholdValueModal } from "./modal";

export const ThresholdValues = ({ allowedValues }: { allowedValues: AllowedValuesDTO }) => {
  const [showException, setShowException] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isThresholdValueModal, setIsThresholdValueModal] = useState(false);

  const {
    data: utilityThresholdData,
    isLoading: thresholdDataLoading,
    refetch: refetchUtilityThreshold,
  } = useQuery({
    queryKey: ["utilityThreshold"],
    queryFn: getUtilityThreshold,
  });

  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 200);
    setIsThresholdValueModal(true);
  };

  const handleCloseThresholdValueModal = () => {
    setIsThresholdValueModal(false);
    refetchUtilityThreshold();
  };

  if (thresholdDataLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex", gap: 6 }}>
      <Box sx={{ minWidth: "240px" }}>
        <Label16SemiBold sx={{ my: 1 }}>Default</Label16SemiBold>
        <Box sx={{ display: "flex", gap: 6 }}>
          <Box>
            <Label14Medium>MoM</Label14Medium>
            <span>15%</span>
          </Box>
          <Box>
            <Label14Medium>YoY</Label14Medium>
            <span>15%</span>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "400px" }}>
        <Label16SemiBold sx={{ my: "5px" }}>Exceptions</Label16SemiBold>
        <Box
          onClick={() => {
            setShowException(false);
            handleClick();
          }}
          sx={{ display: "flex", gap: 1, alignItems: "center", my: 2, cursor: "pointer" }}
        >
          <EsgAddIcon color={isClicked ? "#D98484" : "#C73333"} />
          <Label14SemiBold color={isClicked ? "#D98484" : "#C73333"}>Add new exception</Label14SemiBold>
        </Box>
        {utilityThresholdData?.data?.length > 0 && (
          <Button
            onClick={() => {
              setShowException(true);
              handleClick();
            }}
            variant="contained"
            startIcon={<EyeIcon />}
            sx={{
              color: "white",
              backgroundColor: COLORS.Romance,
              width: "242px",
              height: "36px",
              borderRadius: "8px",
            }}
          >
            <SettingButtonText>View all exceptions</SettingButtonText>
          </Button>
        )}
      </Box>
      <ThresholdValueModal
        isOpen={isThresholdValueModal}
        onClose={handleCloseThresholdValueModal}
        allowedValues={allowedValues}
        showException={showException}
        utilityThresholdData={utilityThresholdData?.data}
      />
    </Box>
  );
};
